import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFirestoreDocument, AngularFirestore } from '@angular/fire/firestore';
import { AngularFireFunctions } from '@angular/fire/functions';
import * as firebase from 'firebase';
import { map } from 'rxjs/operators';
import { NotificationVN } from '../models/notification.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  database = environment.production ? 'Notifications' : 'NotificationsDev';
  databaseTrash = environment.production ? 'NotificationsTrash' : 'NotificationsDevTrash';
  roomEscapeDoc: AngularFirestoreDocument<NotificationVN>;
  constructor(private http: HttpClient,
    private afs: AngularFirestore, private aff: AngularFireFunctions) { }


  get timestamp() {
    return firebase.firestore.FieldValue.serverTimestamp();
  } get ref() {
    return firebase.firestore().collection(this.database);
  }

  create(notification: NotificationVN) {
    notification.i = this.afs.createId();
    const id = notification.i;
    const data = {};
    return this.ref.firestore.doc(this.database + '/' + id).set(Object.assign({}, notification));
  }
//   edit(notification: NotificationVN) {
//     const data = {};
//     data[notification.i] = Object.assign({}, notification);
//     return this.ref.firestore.doc(this.database + '/Notifications').set(data, { merge: true });
//   }
  edit(notification: NotificationVN) {
    return this.ref.firestore.doc(this.database + '/' + notification.i).set(Object.assign({}, notification));
  }
  editVisible (notifiction: NotificationVN, visible: Boolean) {
    this.ref.firestore.doc(this.database + '/' + notifiction.i).update({ v: visible});
  }
  remove(notification: NotificationVN) {
    const data = {};
    data[notification.i] = Object.assign({}, notification);
    this.ref.firestore.doc(this.databaseTrash + '/Notifications').set(data, { merge: true});
    data[notification.i] = firebase.firestore.FieldValue.delete();
    return this.ref.firestore.doc(this.database + '/Notifications').update(data);
  }
  getAll() {
    return this.afs.doc<NotificationVN>(this.database + '/Notifications').snapshotChanges().pipe(
        map(action => {
            if (action.payload.data()) {
                let nots = [];
                Object.keys(action.payload.data()).map(key => {
                    nots.push(action.payload.data()[key]);
                });
                nots = nots.sort((n1, n2) => n1.d > n2.d ? -1 : 1);
                return nots;
            }
            return [];
        })
    );
  }
}
